import React from "react";
import { useLocation } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import tripAdvisorLogo from "../../assets/img/avatars/adviser.png";
import UserNavbar from "components/UserNavbar/UserNavbar";

export default function ConfirmationPage() {
  const { state } = useLocation();
  const {
    fromLabel,
    toLabel,
    phone,
    departure_date,
    adults,
    children,
    infants,
    travel_type,
    direct_flight,
  } = state || {};
  const whatsappNumber = "19052441300"; // Use country code, no symbols
  const message = `Hi, I'm interested in booking a flight. Here are my details:
• From: ${fromLabel}
• To: ${toLabel}
• Departure Date: ${departure_date}
• Travel Type: ${travel_type}
• Adults: ${adults}
• Children: ${children}
• Infants: ${infants}
• Direct Flight: ${direct_flight ? "Yes" : "No"}`;

  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
  return (
    <section className="min-h-screen bg-red-50">
      <UserNavbar />

      {/* Header */}
      <div className="border-b border-red-200 bg-white py-10 px-4 shadow-sm">
        <div className="mx-auto max-w-3xl space-y-4 text-center">
          <h1 className="text-4xl font-extrabold text-red-600">
            🎫 Request Received!
          </h1>
          <p className="text-lg text-gray-700">
            Our team is preparing the best deal for your journey from{" "}
            <span className="font-semibold text-red-500">{fromLabel}</span> to{" "}
            <span className="font-semibold text-red-500">{toLabel}</span>.
            Please hold tight while we confirm your options.
          </p>
        </div>
      </div>

      {/* Side-by-Side Section */}
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Image */}
          <div className="flex w-full justify-center md:w-1/2">
            <img
              src={tripAdvisorLogo}
              alt="Trip Advisor Office"
              className="w-full max-w-md rounded-xl border shadow-md"
            />
          </div>

          {/* Right: Contact Info */}
          <div className="w-full space-y-6 md:w-1/2">
            <div className="rounded-2xl border border-red-300 bg-red-100 p-6 text-center shadow">
              <p className="text-lg font-medium leading-relaxed text-red-800">
                {phone ? (
                  <>
                    📞 Our Fares Specialist, <strong>Mandeep</strong> (TICO Reg.
                    #T1507412), will contact you via call or WhatsApp at{" "}
                    <strong>{phone}</strong>.
                  </>
                ) : (
                  <>
                    📞 Our Fares Specialist <strong>Mandeep</strong> (TICO Reg.
                    #T1507412) is ready to help you. Call us at{" "}
                    <strong>905-244-1300</strong> or{" "}
                    <a
                      href={whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 underline"
                    >
                      message on WhatsApp
                    </a>
                  </>
                )}
              </p>
            </div>

            {/* Trust Info */}
            <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-md">
              <div className="grid grid-cols-1 gap-4 text-gray-700 sm:grid-cols-2">
                <p>
                  <FaLock className="mr-2 inline text-red-500" />
                  SSL Secured Site
                </p>
                <p>✅ TICO Certified – Reg. No. 50027532</p>
                <p>🇨🇦 Canadian-Owned</p>
                <p>💼 Trusted by Thousands</p>
                <p className="sm:col-span-2">
                  🧍‍♂️ Handled by licensed human experts — not bots.
                </p>
                <p className="sm:col-span-2">
                  🏢 Toronto Office: 20 Bay Street, 11th Floor, Toronto, ON
                </p>
              </div>

              <div className="mt-4 flex items-center border-t pt-4">
                <img
                  src={tripAdvisorLogo}
                  alt="Trip Advisor"
                  className="mr-3 h-10 w-auto rounded"
                />
                <span className="text-sm text-gray-600">
                  Registered Trip Advisor Travel Business
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
